export const SIGN_IN = 'SIGN_IN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN ';
export const ERROR = 'ERROR';
export const LOG_OUT = 'LOG_OUT';
export const LOADING_LOGIN = 'LOADING_LOGIN';
export const SELECTED_DATE = 'SELECTED_DATE';
export const LOADING_PREFERENCES = 'LOADING_PREFERENCES';
export const SELECTED_SCALE = 'SELECTED_SCALE';
export const SELECT_COMPANY = 'SELECT_COMPANY';
export const RELOAD_COMPANY = 'RELOAD_COMPANY';
export const REFRESH_IDCONNECTION = 'REFRESH_IDCONNECTION';
export const USER_HAS_PICTURE = 'USER_HAS_PICTURE';


// cashFlow =====================================
export const CF_COINS = 'CF_COINS';
export const CF_COINS_LOADING = 'CF_COINS_LOADING';
export const CF_COMPANIES = 'CF_COMPANIES';
export const CF_COMPANIES_LOADING = 'CF_COMPANIES_LOADING';
export const CF_PROJECTS_BY_COMPANY = 'CF_PROJECTS_BY_COMPANY';
export const CF_PROJECTS_BY_COMPANY_RESET = 'CF_PROJECTS_BY_COMPANY_RESET';
export const CF_CASH_FLOW = 'CF_CASH_FLOW';
export const CF_CASH_FLOW_GET_USER_FILTERS = 'CF_CASH_FLOW_GET_USER_FILTERS';
export const CF_CASH_FLOW_SAVE_USER_FILTERS = 'CF_CASH_FLOW_SAVE_USER_FILTERS';
export const CF_CASH_STRUCTURE = 'CF_CASH_STRUCTURE';
export const CF_CASH_PCG_ITEMS = 'CF_CASH_PCG_ITEMS';
export const CF_CASH_RUBRO_ITEMS = 'CF_CASH_RUBRO_ITEMS';
export const CF_CASH_CDT_ITEMS = 'CF_CASH_CDT_ITEMS';
export const CF_CASH_RESOURCE_ITEMS = 'CF_CASH_RESOURCE_ITEMS';
export const CF_CASH_PCG_ITEMS_RESET = 'CF_CASH_PCG_ITEMS_RESET';
export const CF_CASH_FLOW_RESET = 'CF_CASH_FLOW_RESET';
// logistic Indicators =====================================
export const LI_COINS = 'LI_COINS';
export const LI_COINS_LOADING = 'LI_COINS_LOADING';
export const LI_COMPANIES = 'LI_COMPANIES';
export const LI_COMPANIES_LOADING = 'LI_COMPANIES_LOADING';
export const LI_PROJECTS_BY_COMPANY = 'LI_PROJECTS_BY_COMPANY';
export const LI_PROJECTS_BY_COMPANY_RESET = 'LI_PROJECTS_BY_COMPANY_RESET';

export const LI_BILLS_BY_FAMILY = 'LI_BILLS_BY_FAMILY';
export const LI_BILLS_BY_FAMILY_RESET = 'LI_BILLS_BY_FAMILY_RESET';

export const LI_PAYMENTS_TYPES_LIST = 'LI_PAYMENTS_TYPES_LIST';
export const LI_REQUIREMENTS_ORDER_LIST = 'LI_REQUIREMENTS_ORDER_LIST';
export const LI_BILLS_BY_BUYER = 'LI_BILLS_BY_BUYER';
export const LI_ORDERS_SERVE = 'LI_ORDERS_SERVE';
export const LI_ACCUMULATED_BY_SUPPLIER_PURCHASES = 'LI_ACCUMULATED_BY_SUPPLIER_PURCHASES';
export const LI_PERCENTAGE_BY_ORDER_REQUEST = 'LI_PERCENTAGE_BY_ORDER_REQUEST';

export const CYCLE_BY_PAYMENT_TYPE = 'CYCLE_BY_PAYMENT_TYPE';

export const LI_ELEMENTS_RESET = 'LI_ELEMENTS_RESET';
export const LI_ELEMENTS_TWO_RESET = 'LI_ELEMENTS_TWO_RESET';
export const LI_BILLS_BY_FAMILY_ELEMENTS = 'LI_BILLS_BY_FAMILY_ELEMENTS';

export const LI_CYCLE_BY_PAYMENT_TYPE_ELEMENTS = 'LI_CYCLE_BY_PAYMENT_TYPE_ELEMENTS';
export const LI_PERCENTAGE_BY_ORDER_ELEMENTS = 'LI_PERCENTAGE_BY_ORDER_ELEMENTS';
export const LI_ACCUMULATED_BY_PROVIDER_PURCHASES_ELEMENTS = 'LI_ACCUMULATED_BY_PROVIDER_PURCHASES_ELEMENTS';

export const LI_BILLS_DETAILS_ELEMENTS_TWO = 'LI_BILLS_DETAILS_ELEMENTS_TWO';

export const LI_PERCENTAGE_ATTENDED_ORDERS_ELEMENTS = 'LI_PERCENTAGE_ATTENDED_ORDERS_ELEMENTS';
export const LI_PERCENTAGE_PRODUCTION_BY_BUYER_ELEMENTS = 'LI_PERCENTAGE_PRODUCTION_BY_BUYER_ELEMENTS';
export const LI_PERCENTAGE_REQUIREMENT_NUMBERS_ELEMENTS = 'LI_PERCENTAGE_REQUIREMENT_NUMBERS_ELEMENTS';

export const LI_BUYORDER_RESET = 'LI_BUYORDER_RESET';
export const LI_BUYORDER_DATA = 'LI_BUYORDER_DATA';
export const LI_BUYORDER_CHANGE = 'LI_BUYORDER_CHANGE';
export const LI_BUYORDER_DETAILS = 'LI_BUYORDER_DETAILS';
export const LI_BUYORDER_APPROVALS = 'LI_BUYORDER_APPROVALS';
export const LI_BUYORDER_STORE = 'LI_BUYORDER_STORE';
export const LI_BUYORDER_TO_PAY = 'LI_BUYORDER_TO_PAY';
export const LI_BUYORDER_DETAIL_ORDER = 'LI_BUYORDER_DETAIL_ORDER';
export const LI_BUYORDER_NOTEPAD_UPDATE = 'LI_BUYORDER_NOTEPAD_UPDATE';


// PC
export const LI_BILLS_BY_PC = 'LI_BILLS_BY_PC';
export const LI_BILLS_BY_PC_RESET = 'LI_BILLS_BY_PC_RESET';

export const LI_BILLS_BY_PC_SELECTED_ITEM = 'LI_BILLS_BY_PC_SELECTED_ITEM';
export const LI_BILLS_BY_PC_SELECTED_ITEM_RESET = 'LI_BILLS_BY_PC_SELECTED_ITEM_RESET';

export const LI_BILLS_BY_PC_SELECTED_BILLS_RESET = 'LI_BILLS_BY_PC_SELECTED_BILLS_RESET';
export const LI_BILLS_BY_PC_SELECTED_BILLS = 'LI_BILLS_BY_PC_SELECTED_BILLS';

export const LI_BILLS_BY_PC_SELECTED_BILLS_BY_PERIOD_RESET = 'LI_BILLS_BY_PC_SELECTED_BILLS_BY_PERIOD_RESET';
export const LI_BILLS_BY_PC_SELECTED_BILLS_BY_PERIOD = 'LI_BILLS_BY_PC_SELECTED_BILLS_BY_PERIOD';

// PC General

export const LI_BILLS_BY_PC_GENERAL = 'LI_BILLS_BY_PC_GENERAL';
export const LI_BILLS_BY_PC_GENERAL_RESET = 'LI_BILLS_BY_PC_GENERAL_RESET';

export const LI_BILLS_BY_PC_GENERAL_SELECTED_ITEM = 'LI_BILLS_BY_PC_GENERAL_SELECTED_ITEM';
export const LI_BILLS_BY_PC_GENERAL_SELECTED_ITEM_RESET = 'LI_BILLS_BY_PC_GENERAL_SELECTED_ITEM_RESET';

export const LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS_RESET = 'LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS_RESET';
export const LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS = 'LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS';

export const LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS_BY_PERIOD_RESET = 'LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS_BY_PERIOD_RESET';
export const LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS_BY_PERIOD = 'LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS_BY_PERIOD';
export const LI_BILLS_BY_PC_GENERAL_ELEMENTS = 'LI_BILLS_BY_PC_GENERAL_ELEMENTS';
export const LI_BILLS_BY_PC_GENERAL_ELEMENTS_TWO = 'LI_BILLS_BY_PC_GENERAL_ELEMENTS_TWO';

//signalr =====================================

export const ARBOL = 'ARBOL';
export const TREE_PARTS = 'TREE_PARTS';
export const DATA_GENERAL = 'DATA_GENERAL';
export const ID_DATA_TABLE = 'ID_DATA_TABLE';
export const TREE_COUNT = 'TREE_COUNT';
export const LISTAR_POR_PERIODO = 'LISTAR_POR_PERIODO';
export const PROYECT_DATES = 'PROYECT_DATES';
export const PROJECT_DETAILS = 'PROJECT_DETAILS';
export const LIST_HISTORY = 'LIST_HISTORY';
export const PARTY_CONTROL = 'PARTY_CONTROL';
export const NAVIGATION_TREE = 'NAVIGATION_TREE';
export const NAVIGATION_TREE_PC = 'NAVIGATION_TREE_PC';
export const ID_PC = 'ID_PC';
export const MENSUAL_DETALLE = 'MENSUAL_DETALLE';
export const PROJECT_LIST_DETAILS = 'PROJECT_LIST_DETAILS';
export const TREE_SELECTEDS = 'TREE_SELECTEDS';
export const TREE_SELECTEDS_PC = 'TREE_SELECTEDS_PC';
export const TREE_SELECTEDS_MEANS = 'TREE_SELECTEDS_MEANS';
export const RESET_PROJECT = 'RESET_PROJECT';
export const URL_TREE_PC = 'URL_TREE_PC';
export const URL_TREE_PROJECT = 'URL_TREE_PROJECT';
export const URL_TREE_MEANS = 'URL_TREE_MEANS';
export const HEADER_NAV = 'HEADER_NAV';
export const CLASSIFICATION_DATA = 'CLASSIFICATION_DATA';
export const DELETE_TREE = 'DELETE_TREE';
export const TREE_DE = 'TREE_DE';
export const TREE_FT = 'TREE_FT';
export const CLEAN_TREE_CHILDS = 'CLEAN_TREE_CHILDS';
export const MEANS_TABLE = 'MEANS_TABLE';
export const CLEAN_TREE_MEANS = 'CLEAN_TREE_MEANS';
export const MEANS_DATA = 'MEANS_DATA';

export const TREE_DATA_TAB_3 = 'TREE_DATA_TAB_3';

export const MONTH_RESOURCES = 'MONTH_RESOURCES';
export const RESET_MONTH_RESOURCES = 'RESET_MONTH_RESOURCES';

// =========> Partidas de control general

export const COINS = 'COINS';
export const RESET_TREE_PROJECTS = 'RESET_TREE_PROJECTS';
export const RESET_TREE_CLASSIFICATION = 'RESET_TREE_CLASSIFICATION';
export const RESET_RIGHT_INFORMATION = 'RESET_RIGHT_INFORMATION';
export const RESET_RIGHT_INFORMATION_GRAPHIC = 'RESET_RIGHT_INFORMATION_GRAPHIC';

